import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '@roger/ui-components';

interface AddressSuggestion {
  street?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  county?: string;
  neighborhood?: string;
}

interface AddressSuggestionModalProps {
  addressModalOpen: boolean;
  setAddressModalOpen: (open: boolean) => void;
  addressSuggestion: AddressSuggestion | null;
  handleAcceptAddressSuggestion: () => void;
}

export const AddressSuggestionModal: React.FC<AddressSuggestionModalProps> = ({
  addressModalOpen,
  setAddressModalOpen,
  addressSuggestion,
  handleAcceptAddressSuggestion,
}) => {
  return (
    <Dialog open={addressModalOpen} onOpenChange={setAddressModalOpen}>
      <DialogContent className='max-w-md'>
        <DialogHeader>
          <DialogTitle>Address Suggestion</DialogTitle>
          <DialogDescription>
            We found a validated address based on your input. Would you like to
            use this suggestion?
          </DialogDescription>
        </DialogHeader>
        {addressSuggestion && (
          <div className='py-4'>
            <div className='p-4 border rounded-lg bg-gray-50'>
              <div className='space-y-2 text-sm'>
                <div>
                  <span className='font-medium'>Street:</span>{' '}
                  {addressSuggestion.street || 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>City:</span>{' '}
                  {addressSuggestion.city || 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>State:</span>{' '}
                  {addressSuggestion.state || 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>Zip Code:</span>{' '}
                  {addressSuggestion.zip_code || 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>County:</span>{' '}
                  {addressSuggestion.county || 'N/A'}
                </div>
                {addressSuggestion.neighborhood && (
                  <div>
                    <span className='font-medium'>Neighborhood:</span>{' '}
                    {addressSuggestion.neighborhood}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <DialogFooter className='gap-2'>
          <Button variant='outline' onClick={() => setAddressModalOpen(false)}>
            Keep Original
          </Button>
          <Button onClick={handleAcceptAddressSuggestion}>
            Accept Suggestion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
